import { deviceDetection } from '@marvelapp/core';
export var hasTouch = deviceDetection.isMobile;
export var isMobile = deviceDetection.isMobile, isIOS = deviceDetection.isIOS, isIPad = deviceDetection.isIPad, isIPhone = deviceDetection.isIPhone, isAndroid = deviceDetection.isAndroid;
